import Container from 'typedi';
import OperationRepository from '../repositories/OperationRepository';

class OperationService {
  operationRepository;
  constructor() {
    this.operationRepository = Container.get(OperationRepository);
  }
  getOperations = async (page, rowsPerPage, filters) =>
    await this.operationRepository.getOperations(page, rowsPerPage, filters);
  getStatusByPlanification = async (listOpUuid, planificationId) =>
    await this.operationRepository.getStatusByPlanification(listOpUuid, planificationId);
}
Container.set({ id: OperationService, type: OperationService });

export default OperationService;
